<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="person-search">
      <a-form layout="inline">
        <a-form-item class="name" label="代理商名称">
          <a-input
            class="form-cell"
            type="text"
            v-model="queryParam.agentName"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="地区"
          class="form-oper"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-cascader
            v-if="$store.state.common.address.length > 0"
            class="form-cell"
            :options="$store.state.common.address"
            placeholder="请选择"
            changeOnSelect
            v-model="queryParam.addressSelect"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          />
        </a-form-item>
        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchAgency()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="person-oper">
      <a-button type="primary" icon="plus" @click="$refs.submitForm.init('add')"
        >新建</a-button
      >
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="agencyList"
      class="c-table"
      :pagination="pagination"
      :loading="loading"
      @change="tableChange"
    >
      <span slot="id"></span>
      <span slot="nickname"></span>
      <span slot="address" slot-scope="text, record">
        <template>
          <span
            >{{ record.provinceId | codeFilter }}{{ record.cityId | codeFilter
            }}{{ record.districtId | codeFilter }}</span
          >
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="$refs.submitForm.init('update', record)">修改</a>
          <a-divider type="vertical" />
          <a @click="deleteAgency(record)">删除</a>
        </template>
      </span>
    </a-table>
    <submit-form
      ref="submitForm"
      @addAgency="addAgency"
      @updateAgency="updateAgency"
    ></submit-form>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import agency from '../../api/agency'

import SubmitForm from './SubmitForm'

import { getDate } from '../../utils/date'

import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '代理商名称',
    dataIndex: 'agentName',
    key: 'agentName',
  },
  {
    title: '负责人名称',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '地区',
    dataIndex: 'address',
    key: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'agencyList',
  data() {
    return {
      agencyList: [],
      columns,
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
    }
  },
  components: {
    CTable,
    SubmitForm,
  },
  methods: {
    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${
          sorter.order == 'ascend' ? 'asc' : 'desc'
        }`
      }
      this.getAgencyList(obj)
    },

    //新增一个代理
    addAgency(agency) {
      this.agencyList.unshift(agency)
    },

    //修改一个代理
    updateAgency(agency) {
      for (let i in this.agencyList) {
        if (this.agencyList[i].id == agency.id) {
          this.$set(this.agencyList, i, agency)
        }
      }
    },

    //删除代理
    deleteAgency(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          agency.deleteAgency(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteAgencyData(self.agencyList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteAgencyData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //代理列表
    getAgencyList(params) {
      this.loading = true
      agency.getAgencyList(params).then((res) => {
        console.log('当前的代理列表是', res.data.list)
        this.agencyList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //查询代理
    searchAgency() {
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      this.getAgencyList(obj)
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
      let arr = []
      if (this.queryParam.provinceId) {
        arr[0] = this.queryParam.provinceId
      }
      if (this.queryParam.cityId) {
        arr[1] = this.queryParam.cityId
      }
      if (this.queryParam.districtId) {
        arr[2] = this.queryParam.districtId
      }
      this.queryParam.addressSelect = arr
    } else {
      this.queryParam = {}
    }
    console.log(' this.queryParam', this.queryParam)
    this.getAgencyList(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>
